// Generated by ReScript, PLEASE EDIT WITH CARE


var steppers = {
  hd: {
    label: {
      TAG: /* Text */0,
      _0: "Key Details"
    },
    subtitle: undefined,
    name: /* KeyDetails */0
  },
  tl: {
    hd: {
      label: {
        TAG: /* Text */0,
        _0: "Base Details"
      },
      subtitle: {
        TAG: /* Text */0,
        _0: "(Test)"
      },
      name: /* BaseDetailsTest */1
    },
    tl: {
      hd: {
        label: {
          TAG: /* Text */0,
          _0: "Base Details"
        },
        subtitle: {
          TAG: /* Text */0,
          _0: "(Control)"
        },
        name: /* BaseDetailsControl */2
      },
      tl: {
        hd: {
          label: {
            TAG: /* Text */0,
            _0: "Slab Details"
          },
          subtitle: {
            TAG: /* Text */0,
            _0: "(Test)"
          },
          name: /* SlabDetailsTest */3
        },
        tl: {
          hd: {
            label: {
              TAG: /* Text */0,
              _0: "Slab Details"
            },
            subtitle: {
              TAG: /* Text */0,
              _0: "(Control)"
            },
            name: /* SlabDetailsControl */4
          },
          tl: {
            hd: {
              label: {
                TAG: /* Text */0,
                _0: "Validations"
              },
              subtitle: undefined,
              name: /* EligibilityRules */5
            },
            tl: {
              hd: {
                label: {
                  TAG: /* Text */0,
                  _0: "Preview"
                },
                subtitle: undefined,
                name: /* Preview */6
              },
              tl: /* [] */0
            }
          }
        }
      }
    }
  }
};

export {
  steppers ,
  
}
/* No side effect */
